export const cases = [
  {
    id: "c-01",
    slug: "festival-lineup-shift",
    title: "音乐节阵容调整风波：从「欺诈」指控到补偿方案落地",
    category: "文娱现场",
    status: "已澄清",
    summary:
      "一段 18 秒现场片段把主办方推上风口，指控其在明知阵容变动的情况下继续售票。三天后，场馆方公开的档期沟通邮件改变了讨论方向，补偿方案公布后热度快速回落。",
    focus: "主办方是否在已知阵容变动的前提下继续售票",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20flatlay%20of%20an%20outdoor%20music%20festival%20schedule%20card%2C%20ticket%20stub%20and%20brass%20paper%20clip%20on%20warm%20cream%20paper%2C%20muted%20forest%20green%20and%20ochre%20tones%2C%20soft%20daylight%2C%20minimal%20top%20down%20composition&width=900&height=640&seq=gt-case-01-cover&orientation=landscape",
    publishDate: "2026-09-07",
    updatedDate: "2026-09-10",
    readTime: "约 6 分钟",
    heat: 92,
    tags: ["票务争议", "阵容变动", "补偿方案"],
    timeline: [
      { time: "09-07 21:40", title: "首轮爆料出现", detail: "某账号发布 18 秒现场片段，指控主办方在已知阵容变动的情况下继续售票。", kind: "claim" },
      { time: "09-08 00:15", title: "话题登上热榜", detail: "片段被大量搬运并配上「欺诈」字幕，讨论迅速情绪化。", kind: "spread" },
      { time: "09-08 11:02", title: "主办方首次回应", detail: "公布调整通知的发送时间截图，称变动发生在售票截止之后，但未回应补偿问题。", kind: "response" },
      { time: "09-09 16:30", title: "关键新材料出现", detail: "场馆方公开档期沟通邮件，显示阵容变动在更早时间点已被讨论。", kind: "turn" },
      { time: "09-10 10:00", title: "补偿方案落地", detail: "主办方公布退票与交通补贴方案，讨论转向执行细节与到账时间。", kind: "clarify" },
    ],
    responses: [
      {
        side: "指控方阵容",
        who: "部分购票观众代表",
        stance: "认为主办方信息不透明，构成事实上的误导消费",
        points: [
          "售票页面直到开场前一周仍展示原阵容海报",
          "退票入口在爆料后才出现，此前未主动告知",
          "要求公开阵容变动的完整沟通记录",
        ],
      },
      {
        side: "被指方阵容",
        who: "音乐节主办方",
        stance: "承认通知滞后，但否认在明知变动后继续售票",
        points: [
          "提供调整通知的发送时间截图，称早于售票截止",
          "解释退票通道需要与票务平台对接，存在流程延迟",
          "公布退票与交通补贴方案，并按票面金额全额执行",
        ],
      },
    ],
    wind: [
      { stage: "爆料后 6 小时", proA: 78, proB: 8, neutral: 14, note: "情绪高度集中，几乎一边倒" },
      { stage: "主办方回应后", proA: 61, proB: 22, neutral: 17, note: "质疑方向转向「通知是否到位」" },
      { stage: "场馆邮件公开后", proA: 34, proB: 41, neutral: 25, note: "时间线被修正，判断开始分裂" },
      { stage: "补偿方案发布后", proA: 21, proB: 38, neutral: 41, note: "多数讨论转为执行层面的关心" },
    ],
    clarifications: [
      "阵容变动确实发生，但发生时间早于售票截止时间，原指控中的「明知后仍售票」不成立",
      "主办方通知存在滞后，这一点成立，官方已就此致歉",
      "退票与补贴方案覆盖全部已购票观众，不区分购票渠道",
    ],
    verdict:
      "这是一次典型的「真实问题被错误定性」的反转：观众的不满有现实基础，但最初传播的定性超出材料能支撑的范围。修正后的结论是通知滞后，而非主观欺诈。",
  },
  {
    id: "c-02",
    slug: "short-drama-script-dispute",
    title: "短剧剧本比对争议：比对报告与时间戳谁更有说服力",
    category: "文娱现场",
    status: "反转中",
    summary:
      "两部同期上线的短剧被指情节高度相似，双方各执一词。第三方机构出具的结构比对报告公开后，讨论焦点从「谁抄谁」转向「相似到什么程度才算抄袭」。",
    focus: "情节相似是否构成抄袭，以及判定应依据什么标准",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20flatlay%20of%20two%20stacked%20screenplay%20booklets%20with%20red%20pencil%20marks%20and%20a%20brass%20magnifier%20on%20warm%20cream%20paper%2C%20muted%20forest%20green%20and%20ochre%20tones%2C%20soft%20daylight%2C%20minimal%20top%20down%20composition&width=900&height=640&seq=gt-case-02-cover&orientation=landscape",
    publishDate: "2026-08-29",
    updatedDate: "2026-09-09",
    readTime: "约 7 分钟",
    heat: 78,
    tags: ["创作争议", "比对报告", "时间戳"],
    timeline: [
      { time: "08-29 14:20", title: "观众发现情节雷同", detail: "有观众整理出两部短剧的三处情节对照，发布在社交平台。", kind: "claim" },
      { time: "08-29 22:05", title: "被指方否认", detail: "被指方公布立项文件与剧本时间戳，称创作时间早于对方。", kind: "response" },
      { time: "09-02 10:00", title: "指控方补充材料", detail: "指控方公开更早期的策划群聊记录，时间点早于被指方立项文件。", kind: "turn" },
      { time: "09-06 15:40", title: "第三方比对报告公开", detail: "机构从结构、节奏、人物关系三个维度出具对比结论，认定相似度较高但未认定侵权。", kind: "clarify" },
      { time: "09-09 09:30", title: "双方均表示将走法律程序", detail: "争议进入正式渠道，舆论讨论转向判定标准本身。", kind: "response" },
    ],
    responses: [
      {
        side: "指控方阵营",
        who: "原创编剧团队",
        stance: "主张对方在结构与关键转折上存在实质性复制",
        points: [
          "公开更早期的策划群聊记录，时间早于对方立项文件",
          "指出三处关键转折的台词功能高度一致",
          "要求对方公开完整剧本的版本修改记录",
        ],
      },
      {
        side: "被指方阵营",
        who: "制作方与编剧",
        stance: "否认抄袭，强调同题材的常见桥段不构成独创性表达",
        points: [
          "公布立项文件与剧本时间戳，称创作周期独立",
          "认为群聊记录缺少上下文，无法证明创作完成度",
          "表示将配合第三方比对的完整复核流程",
        ],
      },
    ],
    wind: [
      { stage: "对照图流传阶段", proA: 64, proB: 16, neutral: 20, note: "观众凭直觉判断，声量偏向指控方" },
      { stage: "时间戳公布后", proA: 42, proB: 37, neutral: 21, note: "「创作时间更早」改变了直观印象" },
      { stage: "比对报告公开后", proA: 38, proB: 31, neutral: 31, note: "大量讨论转向「标准是什么」" },
    ],
    clarifications: [
      "比对报告认定结构相似度较高，但未作出侵权认定",
      "双方提供的时间证据指向不同的创作起点，尚无定论",
      "同题材常见桥段的独创性边界，业内本身缺少统一标准",
    ],
    verdict:
      "这类争议很难靠舆论得出答案。材料能证明的只有「相似度较高」，不能证明「谁抄谁」。把它当作一次关于判定标准的公共讨论，比急着站队更有价值。",
  },
  {
    id: "c-03",
    slug: "kitchen-video-case",
    title: "餐厅后厨视频风波：三段剪辑拼出的一场合谋",
    category: "消费维权",
    status: "已澄清",
    summary:
      "三段各 20 秒的后厨视频被拼接发布，指控某连锁餐厅存在严重卫生问题。完整监控释出后，三段画面被证实来自不同日期、不同门店。",
    focus: "视频是否被剪辑拼接，以及原始素材能否支撑指控",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20flatlay%20of%20a%20recipe%20notebook%20with%20loose%20photo%20prints%20clipped%20together%20and%20a%20small%20brass%20magnifier%20on%20warm%20cream%20paper%2C%20muted%20forest%20green%20and%20ochre%20tones%2C%20soft%20daylight%2C%20minimal%20top%20down%20composition&width=900&height=640&seq=gt-case-03-cover&orientation=landscape",
    publishDate: "2026-08-18",
    updatedDate: "2026-08-24",
    readTime: "约 5 分钟",
    heat: 41,
    tags: ["视频剪辑", "门店管理", "原始素材"],
    timeline: [
      { time: "08-18 19:10", title: "拼接视频发布", detail: "三段后厨画面被合成一条 58 秒视频，配文称「同一天连续拍到」。", kind: "claim" },
      { time: "08-19 08:40", title: "品牌方回应", detail: "发布声明称视频存在剪辑，但未提供完整素材，回应被认为缺乏说服力。", kind: "response" },
      { time: "08-21 13:25", title: "门店公开完整监控", detail: "涉事两家门店公布当日全部监控，显示三段画面分属不同日期。", kind: "turn" },
      { time: "08-24 11:00", title: "发布者承认拼接", detail: "原发布者删除视频并作出说明，承认素材来自不同时间。", kind: "clarify" },
    ],
    responses: [
      {
        side: "指控方阵营",
        who: "视频发布者",
        stance: "主张后厨管理存在问题，拼接只为「更直观地说明情况」",
        points: [
          "称原始片段确实拍到不规范操作",
          "解释拼接是为了节省观看时间",
          "认为品牌方的管理问题不应因剪辑而消失",
        ],
      },
      {
        side: "被指方阵营",
        who: "连锁餐饮品牌",
        stance: "承认个别门店存在操作不规范，但否认视频描述的严重程度",
        points: [
          "公布两家门店当日完整监控，证明画面非同一天",
          "承认一处操作流程未按标准执行，对门店作出整改",
          "说明剪辑拼接会放大问题的严重程度",
        ],
      },
    ],
    wind: [
      { stage: "视频发布后 12 小时", proA: 81, proB: 7, neutral: 12, note: "品牌方回应乏力，声量一边倒" },
      { stage: "完整监控公开后", proA: 33, proB: 44, neutral: 23, note: "「同一天」的前提被推翻" },
      { stage: "发布者承认后", proA: 15, proB: 39, neutral: 46, note: "多数人转向讨论剪辑伦理" },
    ],
    clarifications: [
      "三段画面并非同一天拍摄，原视频的核心前提不成立",
      "一家门店确实存在操作流程未按标准执行的情况，已整改",
      "剪辑本身改变了事件的时间关系，构成误导性呈现",
    ],
    verdict:
      "指控里有一小块是真的，但被放进了一个不成立的时间框架里。这类反转最值得记住的一点是：真实的细节不等于真实的整体。",
  },
  {
    id: "c-04",
    slug: "campus-video-edit",
    title: "校园短视频拼接事件：一段被拆开重排的三十秒",
    category: "网络热点",
    status: "已澄清",
    summary:
      "一段 30 秒的校园视频在班级群与本地论坛扩散，被描述为现场冲突。原始素材公开后，画面被确认为按不同时段重新排序。",
    focus: "视频呈现的先后顺序是否与现场实际发生顺序一致",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20flatlay%20of%20a%20stack%20of%20numbered%20photo%20cards%20being%20reordered%20with%20a%20pencil%20and%20brass%20clip%20on%20warm%20cream%20paper%2C%20muted%20forest%20green%20and%20ochre%20tones%2C%20soft%20daylight%2C%20minimal%20top%20down%20composition&width=900&height=640&seq=gt-case-04-cover&orientation=landscape",
    publishDate: "2026-07-30",
    updatedDate: "2026-08-05",
    readTime: "约 4 分钟",
    heat: 33,
    tags: ["二次剪辑", "时间重排", "校园话题"],
    timeline: [
      { time: "07-30 16:50", title: "视频开始扩散", detail: "30 秒视频在本地群聊流传，配文称「现场已经打起来了」。", kind: "claim" },
      { time: "07-31 09:15", title: "校方初步说明", detail: "校方称事件正在了解中，未公布监控，信息真空被进一步填补。", kind: "response" },
      { time: "08-03 14:40", title: "完整素材公开", detail: "校方公布当日监控，显示视频中的画面按时间点被重新排列。", kind: "turn" },
      { time: "08-05 10:20", title: "传播链被梳理", detail: "最早发布者说明视频由他人转发，原始出处未能确认。", kind: "clarify" },
    ],
    responses: [
      {
        side: "指控方阵营",
        who: "视频传播者",
        stance: "称收到视频时即附带该表述，转发时未加核实",
        points: [
          "表示自己并非拍摄者，只是转发",
          "承认未核对视频来源与拍摄时间",
          "在原始素材公开后删除相关帖文",
        ],
      },
      {
        side: "被指方阵营",
        who: "校内相关部门",
        stance: "说明当日确实发生言语争执，但未出现视频描述的肢体冲突",
        points: [
          "公布完整监控，时间顺序与流传视频不一致",
          "说明事件已按校内流程处理完毕",
          "呼吁停止传播涉及未成年的影像",
        ],
      },
    ],
    wind: [
      { stage: "视频扩散阶段", proA: 72, proB: 9, neutral: 19, note: "缺少官方信息，猜测空间被放大" },
      { stage: "校方初步说明后", proA: 64, proB: 18, neutral: 18, note: "「正在了解」被认为是在拖" },
      { stage: "完整素材公开后", proA: 19, proB: 46, neutral: 35, note: "时间重排被证实，声量快速回落" },
    ],
    clarifications: [
      "视频画面真实存在，但播放顺序与现场实际顺序不一致",
      "当日未出现肢体冲突，争执以言语形式发生",
      "最早发布者并非拍摄者，源头仍未确认",
    ],
    verdict:
      "材料是真的，顺序是假的。这类事件里，最容易被忽略的不是画面本身，而是画面之间的那几帧剪辑点。",
  },
  {
    id: "c-05",
    slug: "livestream-price-claim",
    title: "直播带货价格争议：所谓「全网最低」到底怎么算",
    category: "消费维权",
    status: "持续发酵",
    summary:
      "有消费者发现某商品直播间价格与平台日常价接近，「全网最低」的宣传语受到质疑。平台随后公布比价口径，但结算方式的差异让争议继续。",
    focus: "宣传中的「全网最低」是否成立，比价口径是否透明",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20flatlay%20of%20a%20small%20calculator%2C%20price%20tags%20and%20a%20handwritten%20comparison%20sheet%20on%20warm%20cream%20paper%2C%20muted%20forest%20green%20and%20ochre%20tones%2C%20soft%20daylight%2C%20minimal%20top%20down%20composition&width=900&height=640&seq=gt-case-05-cover&orientation=landscape",
    publishDate: "2026-09-02",
    updatedDate: "2026-09-10",
    readTime: "约 6 分钟",
    heat: 66,
    tags: ["价格宣传", "比价口径", "优惠券"],
    timeline: [
      { time: "09-02 20:30", title: "消费者晒出对比", detail: "有用户整理出直播间价格与平台日常价的对照表，质疑宣传用语。", kind: "claim" },
      { time: "09-03 12:10", title: "主播方回应", detail: "说明直播价包含赠品与专属券，折合单价确实更低。", kind: "response" },
      { time: "09-05 17:00", title: "平台公布比价口径", detail: "平台说明「全网最低」按同规格、含券、到手价三个条件比较。", kind: "clarify" },
      { time: "09-09 21:15", title: "争议转向结算方式", detail: "部分用户指出专属券需分单使用，实际到手价与宣传存在差距。", kind: "turn" },
    ],
    responses: [
      {
        side: "质疑方阵营",
        who: "部分消费者",
        stance: "认为宣传口径未说明使用条件，容易造成误解",
        points: [
          "专属券需要拆分成多单才能全部使用",
          "赠品折算单价的方式未在直播间明示",
          "要求统一标注到手价的计算过程",
        ],
      },
      {
        side: "被指方阵营",
        who: "直播机构与平台",
        stance: "强调优惠真实存在，但承认口径说明不够充分",
        points: [
          "公布比价条件，说明按同规格到手价计算",
          "表示将优化直播间价格标注方式",
          "承认结算规则复杂，需要更清晰的指引",
        ],
      },
    ],
    wind: [
      { stage: "对照表流传阶段", proA: 69, proB: 15, neutral: 16, note: "直观的价格差最容易激起共鸣" },
      { stage: "主播方回应后", proA: 58, proB: 27, neutral: 15, note: "赠品折算被接受了一部分" },
      { stage: "结算问题曝光后", proA: 61, proB: 22, neutral: 17, note: "争议回到「怎么算」这个核心" },
    ],
    clarifications: [
      "优惠确实存在，但需要满足分单与凑单条件才能全部使用",
      "「全网最低」的比价口径此前未在直播场景中明确展示",
      "平台已承诺统一标注到手价计算方式",
    ],
    verdict:
      "这起事件还没有真正结束。价格类争议的关键从来不是「便不便宜」，而是「比较的前提是否公开」。口径一旦透明，争论往往会很快收敛。",
  },
  {
    id: "c-06",
    slug: "donation-disclosure-question",
    title: "公益募捐公示质疑：公示表格里的一个计算口径",
    category: "公益舆情",
    status: "已澄清",
    summary:
      "有网友发现某公益项目公示表格中，支出合计与分项相加存在差异。复核后发现差异来自统计口径不同，质疑方在沟通后撤下原帖。",
    focus: "公示表格的合计口径是否清晰，差异是否意味着账目问题",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20flatlay%20of%20a%20printed%20disclosure%20spreadsheet%20with%20a%20brass%20paper%20clip%20and%20pencil%20circling%20a%20row%20of%20numbers%20on%20warm%20cream%20paper%2C%20muted%20forest%20green%20and%20ochre%20tones%2C%20soft%20daylight%2C%20minimal%20top%20down%20composition&width=900&height=640&seq=gt-case-06-cover&orientation=landscape",
    publishDate: "2026-08-11",
    updatedDate: "2026-08-16",
    readTime: "约 5 分钟",
    heat: 58,
    tags: ["公示口径", "账目核对", "公益透明"],
    timeline: [
      { time: "08-11 15:20", title: "质疑帖发布", detail: "网友贴出公示表格，指出支出合计与分项加总相差约 4%。", kind: "claim" },
      { time: "08-12 10:05", title: "机构初步回应", detail: "机构说明差异来自项目管理费单独列示，但未提供逐项明细。", kind: "response" },
      { time: "08-14 14:30", title: "公开逐项明细", detail: "机构公布完整台账，说明管理费按比例单列，不计入项目执行分项。", kind: "turn" },
      { time: "08-16 09:00", title: "质疑方撤下原帖", detail: "质疑方确认差异系口径问题，发布说明并删除原帖。", kind: "clarify" },
    ],
    responses: [
      {
        side: "质疑方阵营",
        who: "关注公示的网友",
        stance: "认为公示表格缺少口径说明，容易引发合理怀疑",
        points: [
          "分项加总与合计存在约 4% 的差额",
          "表格未标注管理费是否计入合计",
          "希望公益机构统一公示模板",
        ],
      },
      {
        side: "被指方阵营",
        who: "项目执行机构",
        stance: "承认表格说明不充分，但账目本身无误",
        points: [
          "公布逐项台账，说明管理费按比例单列",
          "解释合计口径与分项口存在差异的原因",
          "承诺在下一期公示中加入口径注释",
        ],
      },
    ],
    wind: [
      { stage: "质疑帖发布后", proA: 66, proB: 12, neutral: 22, note: "数字差异最容易被读成「有问题」" },
      { stage: "初步回应后", proA: 57, proB: 21, neutral: 22, note: "未给明细，被认为诚意不足" },
      { stage: "逐项明细公开后", proA: 23, proB: 48, neutral: 29, note: "口径差异被解释清楚" },
    ],
    clarifications: [
      "差额来自管理费单列，账目本身不存在缺失",
      "原公示表格缺少口径注释，是引发质疑的直接原因",
      "机构已在后续公示中加入统计口径说明",
    ],
    verdict:
      "一次由「表格设计」引发的风波。数字不会说谎，但排布数字的方式会。公示越需要读者的信任，就越需要把口径写在最前面。",
  },
];

export const caseCategories = ["文娱现场", "网络热点", "消费维权", "公益舆情"];

export const caseStatuses = ["已澄清", "反转中", "持续发酵"];